import React, { FC } from 'react';
import styles from './login_form.module.scss';

type Props = {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  'data-test-id'?: string;
};

export const LoginForm: FC<Props> = ({ children, onSubmit, ...props }) => (
  <form
    className={styles.form}
    onSubmit={onSubmit}
    data-test-id={props['data-test-id']}
  >
    {children}
  </form>
);
